import { Accordion } from "react-bootstrap";
import styled from "styled-components";

export const CensusAccordionHeader = styled(Accordion.Header)`
  .accordion-button {
    padding: 8px 16px;
  }
`;
